import { useEffect, useContext, useRef, useState } from "react";
import PropTypes from "prop-types";
import { SignatureContext } from "../../context/SignatureContext";
import RelativeParser from "../../../../ui/utils/RelativeParser";
import { PageSizeContext } from "../../../../ui/context/page/PageSizeContext";
import { ModalField } from "./components/Modal";
import { getIconFieldByType } from "../../../../ui/utils/fields";
import { useMemo } from "react";


export const SignatureField = ({field, sign}) => {
    const fieldRef = useRef(null);
    const { pageSize } = useContext(PageSizeContext);
    const { signatureState:{ config:{ currentField, sortedFields }}, setFieldRef } = useContext(SignatureContext);
    const configField = useMemo(()=> (sortedFields[field.id]), [sortedFields, field.id]);

    const [openModal, setOpenModal] = useState(false);

    const handleOpen = () => {
        const {target} = event;
            if (!target.classList.contains('signature__field')) return;

        setOpenModal(true)
    };
    const handleClose = () => setOpenModal(false);

    const [ sizeField, setSizeField ] = useState(() => {
        const {width: relativeWidth, height: relativeHeight} = field.position.size;
        const {pageWidth, pageHeight} = pageSize;

        const {x: width, y: height} = RelativeParser.percentageToPixels(relativeWidth, relativeHeight, pageWidth, pageHeight);

        return {width, height};
    });

    // Calcula el tamaño del campo en función del tamaño del contenedor
    useEffect(()=>{
        const {pageWidth, pageHeight} = pageSize;
        const {width: relativeWidth, height: relativeHeight} = field.position.size;

        const sizeField = RelativeParser.percentageToPixels(relativeWidth, relativeHeight, pageWidth, pageHeight);
        const {x: width, y: height} = sizeField;

        setSizeField({width, height});
    },[field.position.size, pageSize]);

    // Verifica si el campo esta reenderizado y si es asi actualiza el nodo
    useEffect(()=>{
        const currentFieldRef = fieldRef.current;
        if(!currentFieldRef || currentField.id !== field.id) return;

        setFieldRef(fieldRef);
    },[currentField.id, field.id, setFieldRef])

    return (
        <div
            ref={fieldRef}
            id={field.id}
            onClick={handleOpen}
            className = {`signature__field ${configField.focus ?'active':''}`}
            style={{
                opacity: configField.isEmpty && !configField.focus ? 0.5 : 1,
                pointerEvents: configField.isEmpty && !configField.focus ? 'none' : 'auto',
                left: `${field.position.coords.x}%`,
                top: `${field.position.coords.y}%`,

                width: sizeField.width,
                height: sizeField.height,
            }}>
            <>
                {
                <div className="signature__field--content">
                    {
                        field.value
                        ? field.type === 'sign' 
                            ? <img 
                                src={field.value} 
                                alt="Imagen de firma"
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                }}/>
                            : <p 
                                className="grey-text"
                                style={{
                                    fontSize: `${Math.max(Math.min(sizeField.height * 0.35, 14), 8)}px`,
                                    width: '90%',
                                    padding: '0 2%',
                                    textOverflow: 'ellipsis',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                }}
                                >{field.value}</p>
                        : field.type === 'sign'
                            ? <span style={{
                                fontSize: `${Math.max(Math.min(sizeField.height * 0.3, 11), 7)}px`,
                                color: 'var(--primary-color)',
                                fontWeight: 600,
                                pointerEvents: 'none',
                                userSelect: 'none',
                              }}>✍ Haz clic para firmar</span>
                            : getIconFieldByType(field.type)
                    }
                </div>
                }
                <ModalField 
                    field={field} 
                    sign={sign}
                    openModal={openModal} 
                    handleClose={handleClose}
                />
            </>
            
        </div>
);}

SignatureField.propTypes = {
    field: PropTypes.object.isRequired,
    sign: PropTypes.string,
    //pageRef: PropTypes.object.isRequired,
};